module.exports = __webpack_public_path__ + "img/communitech-leaf.036a5ba7.svg";